import { render, staticRenderFns } from "./WebsiteSettings.vue?vue&type=template&id=50fa536d"
import script from "./WebsiteSettings.vue?vue&type=script&lang=js"
export * from "./WebsiteSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports